import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const temInit = () => import("@/view/temInit");
const playTem = () => import("@/view/playTem");
const playTemV2 = () => import("@/view/playTemV2");
const playTemV3 = () => import("@/view/playTemV3");
const ruleTem = () => import("@/view/ruleTem");
const playSvgaTem = () => import("@/view/playSvgaTem");
const cashSvgaTem101 = () => import("@/view/cash/svgaTem101");
const cashPayTem101 = () => import("@/view/cash/payTem101");
const cashPayTem102 = () => import("@/view/cash/payTem102");

const pay = () => import("@/view/pay");
const success = () => import("@/view/success");
const refund = () => import("@/view/refund");
const refundV2 = () => import("@/view/refundV2");
const refundV3 = () => import("@/view/refundV3");
const refundSelect = () => import("@/view/refundSelect");
const refundPhone = () => import("@/view/refundPhone");
const actLottery = () => import("@/view/lottery");
const playSvga = () => import("@/view/playSvga");
const playPayTem = () => import("@/view/playPayTem");
const playPayTem2 = () => import("@/view/playPayTem2");
const playInit = () => import("@/view/playInit");
const pay888 = () => import("@/view/pay888");
const pay888top = () => import("@/view/pay888top");
const pay888top117 = () => import("@/view/pay888top117");
const payTel = () => import("@/view/payTel");
const activity1499 = () => import("@/view/pay888-149.9");
const pay888NoRed = () => import("@/view/pay888NoRed");
const pay888v2 = () => import("@/view/pay888v2");
const pay888NoRedv2 = () => import("@/view/pay888NoRedv2");
const pay888NoRedv3 = () => import("@/view/pay888NoRedv3");
const pay888NoRedv4 = () => import("@/view/pay888NoRedv4");
const pay888v3 = () => import("@/view/pay888v3");
const pay888v4 = () => import("@/view/pay888v4");
const pay888v5 = () => import("@/view/pay888v5");
const luckdraw = () => import("@/view/luckdraw");
const luckdraw888 = () => import("@/view/luckdraw888");
const luckdrawSecPay = () => import("@/view/luckdrawSecPay");
const luckdrawSecPayV2 = () => import("@/view/luckdrawSecPayV2");
const hqchl = () => import("@/view/hqchl");
const bizpage0924 = () => import("@/view/bizpage0924");
const bizpage0926 = () => import("@/view/bizpage0926");
const bizpage0929 = () => import("@/view/bizpage0929");
const bizpage0930 = () => import("@/view/bizpage0930");
const bizpage1011 = () => import("@/view/bizpage1011");
const bizpage1014 = () => import("@/view/bizpage1014");

const rule = () => import("@/view/rule");
const topPicks = () => import("@/view/risk/topPicks");
const whiteWine = () => import("@/view/risk/whiteWine");
const lottery = () => import("@/view/risk/lottery");
const bomb = () => import("@/view/risk/bomb");
const bomb2 = () => import("@/view/risk/bomb2");
const bomb3 = () => import("@/view/risk/bomb3");
const bomb4 = () => import("@/view/risk/bomb4");
const happy = () => import("@/view/risk/happy");
const oppo = () => import("@/view/risk/oppo");
const oppov2 = () => import("@/view/risk/oppov2");
const iframe = () => import("@/view/risk/iframe");
const bizpage0924_no = () => import("@/view/risk/bizpage0924");
//话费
const equityPhone = () => import("@/view/equity/phone");
const equityLogin = () => import("@/view/equity/login");
const exchange = () => import("@/view/equity/exchange");
const equityPhoneRule = () => import("@/view/equity/rule");
const activityPhone = () => import("@/view/equity/index");
const telSvga = () => import("@/view/equity/svga");
const telPay = () => import("@/view/equity/telPay");

const cashSvga = () => import("@/view/cash/svga");
const cashSvgav3 = () => import("@/view/cash/svgav3");
const cashSvgaNopop = () => import("@/view/cash/svgaNopop"); 
const adSvga = () => import("@/view/cash/adSvga");
const cashPay = () => import("@/view/cash/pay");
const cashPayv3 = () => import("@/view/cash/payv3");
const cashPayv4 = () => import("@/view/cash/payv4");
const cashPay618 = () => import("@/view/cash/pay618");
const cashInit = () => import("@/view/cash/init");
const cashSvgaTem = () => import("@/view/cash/svgaTem");
const cashPayTem = () => import("@/view/cash/payTem");
const cashPayTem2 = () => import("@/view/cash/payTem2");
const cashPayTem3 = () => import("@/view/cash/payTem3");

const cashLogin = () => import("@/view/cash/login");
const cashRule = () => import("@/view/cash/rule");
const cashRule200 = () => import("@/view/cash/rule200");
const cashRule300 = () => import("@/view/cash/rule300");
const cashExc = () => import("@/view/cash/exchange");
const privacyPolicy = () => import("@/view/privacyPolicy");
const privacyPolicyV2 = () => import("@/view/privacyPolicyV2");
const equityPP = () => import("@/view/equity/privacyPolicy");
const equityPP2 = () => import("@/view/equity/privacyPolicy2");
const riskPP = () => import("@/view/risk/privacyPolicy");
const cashRedAni = () => import("@/view/cash/redAni");
const zhuanpan = () => import("@/view/zhuanpan");
const zhuanpanV2 = () => import("@/view/zhuanpanV2");
const zhuanpanV3 = () => import("@/view/zhuanpanV3");
const zhuanpanV4 = () => import("@/view/zhuanpanV4");

const html = () => import("@/view/html");
const fanhb = () => import("@/view/fanhb");
const fancash = () => import("@/view/fancash");

const huilan = () => import("@/view/gw/huilan");
const lingyue = () => import("@/view/gw/lingyue");

const router = new VueRouter({
  routes: [
    {
      path: "/milkSuccess",
      name: "milkSuccess",
      component: () => import("@/view/custom/milkSuccess.vue"),
      meta: {
        title: "milkSuccess",
      },
    },
    {
      path: "/milk",
      name: "milk",
      component: () => import("@/view/custom/milk.vue"),
      meta: {
        title: "milk",
      },
    },
    {
      path: "/killSuccess",
      name: "killSuccess",
      component: () => import("@/view/custom/killSuccess.vue"),
      meta: {
        title: "killSuccess",
      },
    },
    {
      path: "/videoPay",
      name: "videoPay",
      component: () => import("@/view/custom/video.vue"),
      meta: {
        title: "videoPay",
      },
    },
    {
      path: "/successV1",
      name: "successV1",
      component: () => import("@/view/custom/paySuccessV1.vue"),
      meta: {
        title: "successV1",
      },
    },
    {
      path: "/successV2",
      name: "successV2",
      component: () => import("@/view/custom/paySuccessV2.vue"),
      meta: {
        title: "successV2",
      },
    },
    {
      path: "/happyPay",
      name: "happyPay",
      component: () => import("@/view/custom/happyPay.vue"),
      meta: {
        title: "happyPay",
      },
    },
    {
      path: "/happyPayV2",
      name: "happyPayV2",
      component: () => import("@/view/custom/happyPayV2.vue"),
      meta: {
        title: "happyPayV2",
      },
    },
    {
      path: "/benefit",
      name: "benefit",
      component: () => import("@/view/custom/benefit.vue"),
      meta: {
        title: "benefit",
      },
    },
    {
      path: "/video",
      name: "video",
      component: () => import("@/view/custom/video.vue"),
      meta: {
        title: "video",
      },
    },
    {
      path: "/wineSuccess",
      name: "wineSuccess",
      component: () => import("@/view/custom/wineSuccess.vue"),
      meta: {
        title: "wineSuccess",
      },
    },
    {
      path: "/moneySuccess",
      name: "moneySuccess",
      component: () => import("@/view/custom/moneySuccess.vue"),
      meta: {
        title: "moneySuccess",
      },
    },
    {
      path: "/hdAuto",
      name: "hdAuto",
      component: () => import("@/view/act/hdAuto.vue"),
      meta: {
        title: "hdAuto",
      },
    },
    {
      path: "/hdAutoBlank",
      name: "hdAutoBlank",
      component: () => import("@/view/act/hdAutoBlank.vue"),
      meta: {
        title: "hdAutoBlank",
      },
    },
    {
      path: "/hd",
      name: "hd",
      component: () => import("@/view/act/hd.vue"),
      meta: {
        title: "hd",
      },
    },
    {
      path: "/autoLeLingPay",
      name: "autoLeLingPay",
      component: () => import("@/view/autoPay/autoLeLingPay.vue"),
      meta: {
        title: "自动支付",
      },
    },
    {
      path: "/takeout",
      name: "takeout",
      component: () => import("@/view/custom/takeout.vue"),
      meta: {
        title: "外卖",
      },
    },
    {
      path: "/mallPaySuccess",
      name: "mallPaySuccess",
      component: () => import("@/view/custom/mallPaySuccess.vue"),
      meta: {
        title: "支付成功",
      },
    },
    {
      path: "/memberPaySuccess",
      name: "memberPaySuccess",
      component: () => import("@/view/custom/memberPaySuccess.vue"),
      meta: {
        title: "支付成功",
      },
    },
    {
      path: "/exchangeLogin",
      name: "exchangeLogin",
      component: () => import("@/view/custom/exchange/exchangeLogin.vue"),
      meta: {
        title: "支付完成",
      },
    },
    {
      path: "/exchangeDetail",
      name: "exchangeDetail",
      component: () => import("@/view/custom/exchange/exchangeDetail.vue"),
      meta: {
        title: "会员兑换",
      },
    },
    {
      path: "/winePrivacy",
      name: "wine_privacy",
      component: () => import("@/view/wine/winePrivacy.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/winePaySuccess",
      name: "wine_pay_success",
      component: () => import("@/view/wine/winePaySuccess.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/wine",
      name: "wine",
      component: () => import("@/view/wine/wine.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/wineV2",
      name: "wineV2",
      component: () => import("@/view/wine/wineAvoid.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/wineV3",
      name: "wineV3",
      component: () => import("@/view/wine/wineV3.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/wineV4",
      name: "wineV4",
      component: () => import("@/view/wine/wineV4.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/wineV5",
      name: "wineV5",
      component: () => import("@/view/wine/wineV5.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/wineV6",
      name: "wineV6",
      component: () => import("@/view/wine/wineV6.vue"),
      meta: {
        title: "wine",
      },
    },
    {
      path: "/sjys",
      name: "sjys",
      component: () => import("@/view/wine/sjys.vue"),
      meta: {
        title: "sjys",
      },
    },
    {
      path: "/easeV1",
      name: "easeV1",
      component: () => import("@/view/ease/easeV1.vue"),
      meta: {
        title: "ease",
      },
    },
    {
      path: "/easeV2",
      name: "easeV2",
      component: () => import("@/view/ease/easeV2.vue"),
      meta: {
        title: "ease",
      },
    },
    {
      path: "/easeV3",
      name: "easeV3",
      component: () => import("@/view/ease/easeV3.vue"),
      meta: {
        title: "ease",
      },
    },
    {
      path: "/easeV4",
      name: "easeV4",
      component: () => import("@/view/ease/easeV4.vue"),
      meta: {
        title: "ease",
      },
    },
    {
      path: "/luckdrawPhone",
      name: "luckdrawPhone",
      component: () => import("@/view/new/luckdrawPhone.vue"),
      meta: {
        title: "请输入信息"
      },
    },    
    // 新增代扣款退款页面 有谷歌验证码
    {
      path: "/refundWithhold",
      name: "refundWithhold",
      component: () => import("@/view/withhold/refundWithhold.vue"),
      meta: {
        title: "自助退款",
      },
    },
    // 新增代扣款退款页面 无谷歌验证码
    {
      path: "/refundWithhold2",
      name: "refundWithhold2",
      component: () => import("@/view/withhold/refundWithhold2.vue"),
      meta: {
        title: "自助退款",
      },
    },
    // 新增手机号支付页面
    {
      path: "/payPhone",
      name: "payPhone",
      component: () => import("@/view/withhold/payPhone.vue"),
      meta: {
        title: "请输入信息",
      },
    },
    // 新增银行卡页面
    {
      path: "/bankcardSelect",
      name: "bankcardSelect",
      component: () => import("@/view/withhold/BankcardSelect.vue"),
      meta: {
        title: "请输入信息",
      },
    },
    {
      path: "/temInit",
      name: "temInit",
      component: temInit,
    },
    {
      path: "/playSvgaTem",
      name: "playSvgaTem",
      component: playSvgaTem,
    },
    {
      path: "/playTem",
      name: "playTem",
      component: playTem,
    },
    {
      path: "/playTemV2",
      name: "playTemV2",
      component: playTemV2,
    },
    {
      path: "/playTemV3",
      name: "playTemV3",
      component: playTemV3,
    },

    {
      path: "/ruleTem",
      name: "ruleTem",
      component: ruleTem,
    },

    {
      path: "/cashSvgaTem101",
      name: "cashSvgaTem101",
      component: cashSvgaTem101,
    },

    {
      path: "/cashPayTem101",
      name: "cashPayTem101",
      component: cashPayTem101,
    },

    {
      path: "/cashPayTem102",
      name: "cashPayTem102",
      component: cashPayTem102,
    },

    {
      path: "/",
      name: "pay_bg",
      component: { render: h => h("div", "OK") },
      meta: {
        title: "OK",
      },
    },
    {
      path: "/html",
      name: "html",
      component: html,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playSvga",
      name: "playSvga",
      component: playSvga,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playPayTem",
      name: "playPayTem",
      component: playPayTem,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playPayTem2",
      name: "playPayTem2",
      component: playPayTem2,
      meta: {
        title: "看短剧抽红包",
      },
    },

    {
      path: "/playSvgaV1",
      name: "playSvgaV1",
      component: playInit,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playSvgaV2",
      name: "playSvgaV2",
      component: playInit,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playSvgaV3",
      name: "playSvgaV3",
      component: playInit,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playSvgaV4",
      name: "playSvgaV4",
      component: playInit,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/playSvgaV5",
      name: "playSvgaV5",
      component: playInit,
      meta: {
        title: "看短剧抽红包",
      },
    },

    {
      path: "/activity",
      name: "activity",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activity499",
      name: "activity499",
      component: pay888,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activity989",
      name: "activity989",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activity99",
      name: "activity99",
      component: pay888,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activity1499",
      name: "activity1499",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activity1489",
      name: "activity1489",
      component: pay888,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activity14999",
      name: "activity1499",
      component: activity1499,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1499",
      name: "act1499",
      component: pay888,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1699",
      name: "act1699",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1499v3",
      name: "act1499v3",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1699v3",
      name: "act1699v3",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },

    {
      path: "/act198",
      name: "act198",
      component: pay888top117,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act198v2",
      name: "act198",
      component: pay888NoRed,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1699v2",
      name: "act1699",
      component: pay888v3,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/actTel1499",
      name: "actTel1499",
      component: payTel,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/activityNoRed",
      name: "activityNoRed",
      component: pay888NoRed,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/actNoRed99",
      name: "activity99",
      component: pay888NoRedv2,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/actNoRed1499",
      name: "actNoRed1499",
      component: pay888NoRedv3,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1499txt",
      name: "act1489v5",
      component: pay888NoRedv4,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act99v2",
      name: "act99v2",
      component: pay888v2,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act149v2",
      name: "act149v2",
      component: pay888v2,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act149v3",
      name: "act149v3",
      component: pay888top,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1489v3",
      name: "act1489v3",
      component: pay888v3,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1699v4",
      name: "act1699v4",
      component: pay888v3,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1489v4",
      name: "act1489v3",
      component: pay888v4,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/act1489v5",
      name: "act1489v5",
      component: pay888v5,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/bizpage0924",
      name: "bizpage0924",
      component: bizpage0924,
      meta: {
        title: "看短剧抽手机",
      },
    },
    {
      path: "/bizpage0926",
      name: "bizpage0926",
      component: bizpage0926,
      meta: {
        title: "办业务抽手机",
      },
    },
    {
      path: "/bizpage0929",
      name: "bizpage0929",
      component: bizpage0929,
      meta: {
        title: "点击抽电瓶车！",
      },
    },
    {
      path: "/bizpage0930",
      name: "bizpage0930",
      component: bizpage0930,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/bizpage1011",
      name: "bizpage1011",
      component: bizpage1011,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/bizpage1014",
      name: "bizpage1014",
      component: bizpage1014,
      meta: {
        title: "看短剧抽红包",
      },
    },

    {
      path: "/success",
      name: "success",
      component: success,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/refund",
      name: "refund",
      component: refund,
      meta: {
        title: "快速退款",
      },
    },

    {
      path: "/refundV2",
      name: "refundV2",
      component: refundV2,
      meta: {
        title: "快速退款",
      },
    },
    {
      path: "/refundV3",
      name: "refundV3",
      component: refundV3,
      meta: {
        title: "快速退款",
      },
    },
    {
      path: "/refundSelect",
      name: "refundSelect",
      component: refundSelect,
      meta: {
        title: "快速退款",
      },
    },

    {
      path: "/refundPhone",
      name: "refundPhone",
      component: refundPhone,
      meta: {
        title: "快速退款",
      },
    },

    {
      path: "/luckdraw",
      name: "luckdraw",
      component: luckdraw,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/luckdraw888",
      name: "luckdraw888",
      component: luckdraw888,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/luckdrawSecPay",
      name: "luckdrawSecPay",
      component: luckdrawSecPay,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/luckdrawSecPayV2",
      name: "luckdrawSecPayV2",
      component: luckdrawSecPayV2,
      meta: {
        title: "看短剧抽红包",
      },
    },

    {
      path: "/rule",
      name: "rule",
      component: rule,
      meta: {
        title: "活动规则",
      },
    },
    {
      path: "/actLottery",
      name: "actLottery",
      component: actLottery,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/whiteWine",
      name: "whiteWine",
      component: whiteWine,
      meta: {
        title: "",
      },
    },
    {
      path: "/topPicks",
      name: "topPicks",
      component: topPicks,
      meta: {
        title: "热门精选",
      },
    },
    {
      path: "/lottery",
      name: "lottery",
      component: lottery,
      meta: {
        title: "大转盘",
      },
    },
    {
      path: "/bomb",
      name: "bomb",
      component: bomb,
      meta: {
        title: "视频彩铃",
      },
    },
    {
      path: "/riskPP",
      name: "riskPP",
      component: riskPP,
      meta: {
        title: "隐私协议",
      },
    },
    {
      path: "/bomb2",
      name: "bomb2",
      component: bomb2,
      meta: {
        title: "视频彩铃",
      },
    },
    {
      path: "/bomb3",
      name: "bomb3",
      component: bomb3,
      meta: {
        title: "随心选权益包",
      },
    },
    {
      path: "/bomb4",
      name: "bomb4",
      component: bomb4,
      meta: {
        title: "随心选权益包",
      },
    },
    {
      path: "/bizpage0924_no",
      name: "bizpage0924_no",
      component: bizpage0924_no,
      meta: {
        title: "看短剧抽手机",
      },
    },

    {
      path: "/oppo",
      name: "oppo",
      component: oppo,
      meta: {
        title: "购物领券拿返利",
      },
    },
    {
      path: "/oppov2",
      name: "oppov2",
      component: oppov2,
      meta: {
        title: "购物领券拿返利",
      },
    },
    {
      path: "/happy",
      name: "happy",
      component: happy,
      meta: {
        title: "年卡超划算 优惠不错过",
      },
    },

    {
      path: "/actPage",
      name: "iframe",
      component: iframe,
    },

    {
      path: "/equity/activityPhone",
      name: "activityPhone",
      component: activityPhone,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/telSvga",
      name: "activityPhone",
      component: telSvga,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/telPay",
      name: "telPay",
      component: telPay,
      meta: {
        title: "云响权益平台",
      },
    },

    {
      path: "/equity/phone",
      name: "equityPhone",
      component: equityPhone,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/phoneV2",
      name: "equityPhoneV2",
      component: () => import("@/view/equity/phoneV2.vue"),
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/login",
      name: "equityLogin",
      component: equityLogin,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/exchange",
      name: "exchange",
      component: exchange,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/phoneRule",
      name: "equityPhoneRule",
      component: equityPhoneRule,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/privacyPolicy2",
      name: "equityPP2",
      component: equityPP2,
      meta: {
        title: "云响权益平台",
      },
    },
    {
      path: "/equity/privacyPolicy",
      name: "equityPP",
      component: equityPP,
      meta: {
        title: "云响权益平台",
      },
    },

    //立减金
    {
      path: "/cash/red200",
      name: "cashPay200",
      component: cashSvga,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300",
      name: "cashPay300",
      component: cashSvga,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red200Nopop",
      name: "cashPay200",
      component: cashSvgaNopop,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300Nopop",
      name: "cashPay300",
      component: cashSvgaNopop,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red200v2",
      name: "cashPay200v2",
      component: cashSvga,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300v2",
      name: "cashPay300v2",
      component: cashSvga,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red200Nopopv2",
      name: "cashPay200v2",
      component: cashSvgaNopop,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300Nopopv2",
      name: "cashPay300v2",
      component: cashSvgaNopop,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/ad200Svga",
      name: "adSvga",
      component: adSvga,
      meta: {
        title: "恭喜您中奖了！",
      },
    },    
    {
      path: "/cash/pay200",
      name: "cash200",
      component: cashPay618,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/pay300",
      name: "cash300",
      component: cashPay618,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/pay200v2",
      name: "cash200v2",
      component: cashPay,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/pay300v2",
      name: "cash300v2",
      component: cashPay,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300v3",
      name: "cashPay300v3",
      component: cashSvgav3,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300v4",
      name: "cashPay300v4",
      component: cashSvgav3,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/pay300v3",
      name: "cash_Pay300_v3",
      component: cashPayv3,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/pay300v4",
      name: "cash_Pay300_v4",
      component: cashPayv4,
      meta: {
        title: "权享通",
      },
    },

    {
      path: "/cash/red80-200",
      name: "cashRed80-200",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red80-200v2",
      name: "cashRed80-200v2",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red99-200",
      name: "cashRed99-200",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red99-200v2",
      name: "cashRed99-200v2",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red119-300",
      name: "cashRed119-300",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red119-300v2",
      name: "cashRed119-300v2",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red80-200v3",
      name: "cashRed80-200v3",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red80-200v4",
      name: "cashRed80-200v4",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red80-200v5",
      name: "cashRed80-200v5",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red100-200",
      name: "cashRed100-200",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red150-300",
      name: "cashRed150-300",
      component: cashInit,
      meta: {
        title: "权享通",
      },
    },

    {
      path: "/cash/svgaTem",
      name: "cashSvgaTem",
      component: cashSvgaTem,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/payTem",
      name: "cashPayTem",
      component: cashPayTem,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/payTem2",
      name: "cashPayTem2",
      component: cashPayTem2,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/payTem3",
      name: "cashPayTem3",
      component: cashPayTem3,
      meta: {
        title: "权享通",
      },
    },

    {
      path: "/cash/red200Ani",
      name: "cashPay200v2",
      component: cashRedAni,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/red300Ani",
      name: "cashPay300v2",
      component: cashRedAni,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/login",
      name: "cashLogin",
      component: cashLogin,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/exc",
      name: "cashExc",
      component: cashExc,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/rule200",
      name: "cashRule200",
      component: cashRule200,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/rule300",
      name: "cashRule300",
      component: cashRule300,
      meta: {
        title: "权享通",
      },
    },
    {
      path: "/cash/rule",
      name: "cashRule",
      component: cashRule,
      meta: {
        title: "活动规则",
      },
    },

    {
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: privacyPolicy,
      meta: {
        title: "隐私政策",
      },
    },
    {
      path: "/privacyPolicyV2",
      name: "privacyPolicyV2",
      component: privacyPolicyV2,
      meta: {
        title: "隐私政策",
      },
    },

    {
      path: "/zhuanpan",
      name: "zhuanpan",
      component: zhuanpan,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/zhuanpanV2",
      name: "zhuanpanV2",
      component: zhuanpanV2,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/zhuanpanV3",
      name: "zhuanpanV3",
      component: zhuanpanV3,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/zhuanpanV4",
      name: "zhuanpanV4",
      component: zhuanpanV4,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/zhuanpanV5",
      name: "zhuanpanV5",
      component: () => import("@/view/zhuanpanV5.vue"),
      meta: {
        title: "抽奖",
      },
    },
    {
      path: "/fanhb",
      name: "fanhb",
      component: fanhb,
      meta: {
        title: "看短剧抽红包",
      },
    },
    {
      path: "/hqchl",
      name: "hqchl",
      component: hqchl,
      meta: {
        title: "看短剧抽红包",
      },
    },

    {
      path: "/fancash300",
      name: "fancash300",
      component: fancash,
      meta: {
        title: "权享通",
      },
    },

    {
      path: "/huilan",
      name: "huilan",
      component: huilan,
      meta: {
        title: "汇澜网络",
      },
    },
    {
      path: "/lingyue",
      name: "lingyue",
      component: lingyue,
      meta: {
        title: "超慧网络",
      },
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js